import React, { useRef, useState, useEffect, useCallback } from "react"
import NotificationAlert from 'react-notification-alert';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from 'moment'
import {
    FormGroup,
    Label,
    Input,
    Button,
    Card,
    CardHeader,
    CardBody,
    CardFooter,
    Row,
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    InputGroup
} from "reactstrap";

import UserService from '../../services/user.service.v3';
import ToolService from '../../services/tool.service';
import OrderService from '../../services/order.service';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Select from 'react-select';

function OrderExtend(props) {
    const notificationAlertRef = useRef(null);

    const [userFind, setUserFind] = useState('')
    const [userData, setUserData] = useState(null)
    const [userList, setUserList] = useState([])
    const [showUserDropdown, setShowUserDropdown] = useState(false)
    const [isSearching, setIsSearching] = useState(false)

    const [email, setEmail] = useState('')
    const [fullName, setFullName] = useState('')
    const [username, setUsername] = useState('')
    const [version, setVersion] = useState('Thường')
    const [accountStatus, setAccountStatus] = useState('')

    const [message, setMessage] = useState('')
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    // Dropdown cho Tool selector
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(prevState => !prevState);
    const [toolName, setToolName] = useState("Reup Youtube");
    const [selectedTool, setSelectedTool] = useState("dhbreupyoutube");
    const [toolList, setToolList] = useState([]);

    const [showload, setShowload] = useState(false)
    const [showlookup, setShowlookup] = useState(false)
    const [showCopy, setShowCopy] = useState(false)

    const [optionsThoiHan, setOptionsThoiHan] = useState([])
    const [thoiHan, setThoiHan] = useState(null)

    const [paymentMethod, setPaymentMethod] = useState("Chuyển khoản")
    const [price, setPrice] = useState('300000')
    const [qrCodeUrl, setQrCodeUrl] = useState('')

    const [order, setOrder] = useState(null)

    const back = () => props.changePage('', 'add', null);

    useEffect(() => {
        loadTools();
    }, [])

    useEffect(() => {
        loadToolAttributes();
    }, [selectedTool])

    function showNotification(message, type = "success") {
        const options = {
            place: 'tc',
            message: (
                <div>
                    <div>
                        {message}
                    </div>
                </div>
            ),
            type: type,
            icon: "nc-icon nc-check-2",
            autoDismiss: 3
        };

        notificationAlertRef.current.notificationAlert(options);
    }

    function loadTools() {
        ToolService.getTool().then((result) => {
            if (result.data && result.data.length > 0) {
                setToolList(result.data);
                // Nếu chưa chọn tool thì set mặc định tool đầu tiên
                if (!selectedTool && result.data.length > 0) {
                    setSelectedTool(result.data[0].code);
                    setToolName(result.data[0].name);
                }
            }
        }).catch(error => {
            console.error("Lỗi khi tải danh sách công cụ:", error);
        });
    }

    function loadToolAttributes() {
        if (!selectedTool) return;

        ToolService.getAttribute(selectedTool).then((result) => {
            result.data.forEach(item => {
                if (item.name.toLowerCase() == "thời hạn") {
                    setOptionsThoiHan(item.options)
                    setThoiHan(item.options[0])
                }
            });
        })
    }

    const optionsPaymentMethod = [
        { value: 'Chuyển khoản', label: 'Chuyển khoản' },
        { value: 'Ví MoMo', label: 'Ví MoMo' },
        { value: 'Binance Pay', label: 'Binance Pay' },
        { value: 'Onchain USDT', label: 'Onchain USDT' },
    ];

    // Thêm debounce function cho tìm kiếm realtime
    const debounce = (func, delay) => {
        let debounceTimer;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        }
    }

    // Tìm kiếm realtime với debounce
    const debouncedSearch = useCallback(
        debounce((searchTerm) => {
            if (searchTerm.length >= 3) {
                searchUsers(searchTerm);
            } else {
                setShowUserDropdown(false);
                setUserList([]);
            }
        }, 500),
        [selectedTool]
    );

    // Hàm xử lý khi thay đổi giá trị ô tìm kiếm
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setUserFind(value);
        debouncedSearch(value);
    };

    // Hàm tìm kiếm người dùng
    function searchUsers(searchTerm) {
        if (!searchTerm || searchTerm.length < 3) {
            return;
        }

        setIsSearching(true);
        setShowUserDropdown(false);

        UserService.findUser(selectedTool, searchTerm)
            .then((result) => {
                setIsSearching(false);

                if (result.data.users && result.data.users.length > 0) {
                    if (result.data.users.length === 1) {
                        // Nếu chỉ có một người dùng, đặt trực tiếp
                        const user = result.data.users[0];
                        setUserData(user);
                        setEmail(user.email);
                        setFullName(user.fullname);
                        setUsername(user.username);
                        setVersion(user.version);
                        setShowUserDropdown(false);

                        // Kiểm tra nếu user.expired tồn tại và là một giá trị hợp lệ
                        if (user.expired && moment(user.expired).isValid()) {
                            const daysRemaining = moment(user.expired).diff(moment(), 'days');
                            if (daysRemaining < 0) {
                                setAccountStatus('Đã hết hạn');
                            } else {
                                setAccountStatus(`Còn hạn ${daysRemaining} ngày`);
                            }
                        } else {
                            // Xử lý trường hợp ngày hết hạn không hợp lệ
                            setAccountStatus('Không xác định');
                            console.error('Ngày hết hạn không hợp lệ:', user.expired);
                        }
                    } else {
                        // Nếu có nhiều người dùng, hiển thị dropdown
                        setUserList(result.data.users);
                        setShowUserDropdown(true);
                    }
                } else {
                    setShowUserDropdown(false);
                    setUserList([]);
                }
            }).catch(error => {
                setIsSearching(false);
                setUserData(null);
                setShowUserDropdown(false);

                if (error.response) {
                    // Xử lý lỗi từ phản hồi server nếu cần
                    console.error("Lỗi khi tìm kiếm:", error.response.data);
                } else if (error.request) {
                    console.error("Lỗi kết nối:", error.request);
                } else {
                    console.error("Lỗi:", error.message);
                }
            });
    }

    function lookupUser() {
        if (!userFind) {
            showNotification("Vui lòng nhập tài khoản hoặc email", "danger")
            return;
        }

        setShowlookup(true);
        setShowUserDropdown(false);
        setUserList([]);

        UserService.findUser(selectedTool, userFind)
            .then((result) => {
                setShowlookup(false);

                if (result.data.users && result.data.users.length > 0) {
                    if (result.data.users.length === 1) {
                        // Nếu chỉ có một người dùng, đặt trực tiếp
                        const user = result.data.users[0];
                        setUserData(user);
                        setFullName(user.fullname);
                        setEmail(user.email);
                        setUsername(user.username);
                        setVersion(user.version);

                        // Kiểm tra nếu user.expired tồn tại và là một giá trị hợp lệ
                        if (user.expired && moment(user.expired).isValid()) {
                            const daysRemaining = moment(user.expired).diff(moment(), 'days');
                            if (daysRemaining < 0) {
                                setAccountStatus('Đã hết hạn');
                            } else {
                                setAccountStatus(`Còn hạn ${daysRemaining} ngày`);
                            }
                        } else {
                            // Xử lý trường hợp ngày hết hạn không hợp lệ
                            setAccountStatus('Không xác định');
                            console.error('Ngày hết hạn không hợp lệ:', user.expired);
                        }
                    } else {
                        // Nếu có nhiều người dùng, hiển thị dropdown
                        setUserList(result.data.users);
                        setShowUserDropdown(true);
                    }
                } else {
                    showNotification("Không tìm thấy người dùng", "danger");
                }
            }).catch(error => {
                setShowlookup(false);
                setUserData(null);

                if (error.response) {
                    // Xử lý lỗi từ phản hồi server
                    if (error.response.status === 403) {
                        showNotification("Bạn không có quyền truy cập thông tin này", "danger");
                    } else {
                        showNotification(error.response.data.message || "Đã xảy ra lỗi khi tìm kiếm người dùng", "danger");
                    }
                } else if (error.request) {
                    // Yêu cầu đã được gửi nhưng không nhận được phản hồi
                    showNotification("Không thể kết nối đến máy chủ, vui lòng thử lại sau", "danger");
                } else {
                    // Lỗi khi thiết lập yêu cầu
                    showNotification(error.message || "Đã xảy ra lỗi không xác định", "danger");
                }
            });
    }

    function selectUser(user) {
        setUserData(user);
        setEmail(user.email);
        setFullName(user.fullname);
        setUsername(user.username);
        setVersion(user.version);
        setShowUserDropdown(false);

        // Kiểm tra nếu user.expired tồn tại và là một giá trị hợp lệ
        if (user.expired && moment(user.expired).isValid()) {
            const daysRemaining = moment(user.expired).diff(moment(), 'days');
            if (daysRemaining < 0) {
                setAccountStatus('Đã hết hạn');
            } else {
                setAccountStatus(`Còn hạn ${daysRemaining} ngày`);
            }
        }
    }

    function createSuccessExtendOrder() {
        if (!userData) {
            Swal.fire({
                icon: 'error',
                title: 'Vui lòng tìm kiếm tài khoản trước',
                showConfirmButton: false,
                timer: 1500
            })
            return;
        }

        setShowload(true)

        // Tính toán ngày hết hạn mới dựa trên thời hạn được chọn
        const newExpiredDate = moment(userData.expired).isAfter(moment())
            ? moment(userData.expired).add(thoiHan.exp, 'days').format('MM/DD/YYYY')
            : moment().add(thoiHan.exp, 'days').format('MM/DD/YYYY');

        UserService.createSuccessExtendOrder(selectedTool, userData.id, { expired: newExpiredDate })
            .then(result => {
                setShowload(false)
                if (result.data.success) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Gia hạn thành công',
                        showConfirmButton: false,
                        timer: 1000
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gia hạn thất bại',
                        text: result.data.message || 'Đã xảy ra lỗi khi gia hạn',
                        showConfirmButton: true
                    })
                }
            }).catch(error => {
                setShowload(false)
                if (error.response) {
                    if (error.response.status === 404) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Không tìm thấy người dùng',
                            text: 'Người dùng không tồn tại hoặc đã bị xóa',
                            showConfirmButton: true
                        })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Lỗi từ máy chủ',
                            text: error.response.data.message || 'Đã xảy ra lỗi khi gia hạn',
                            showConfirmButton: true
                        })
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Lỗi kết nối',
                        text: 'Không thể kết nối đến máy chủ, vui lòng thử lại sau',
                        showConfirmButton: true
                    })
                }
            })
    }

    function createWaitingExtendOrder() {
        if (!userData) {
            showNotification("Vui lòng tìm kiếm tài khoản trước", "danger")
            return;
        }

        setShowload(true)

        // Tính toán ngày hết hạn mới dựa trên thời hạn được chọn
        const newExpiredDate = moment(userData.expired).isAfter(moment())
            ? moment(userData.expired).add(thoiHan.exp, 'days').format('MM/DD/YYYY')
            : moment().add(thoiHan.exp, 'days').format('MM/DD/YYYY');

        var body = {
            fullname: fullName,
            email: email,
            username: username,
            thoihan: thoiHan.value,
            version: version,
            status: 'pending'
        }

        UserService.createWaitingExtendOrder(selectedTool, userData.id, body)
            .then(result => {
                setShowload(false)

                if (result.data.success) {
                    setOrder(result.data.order)

                    // Lấy ID đơn hàng từ response
                    const orderID = result.data.order.id;

                    // Tạo URL QR code với giá tiền và ID đơn hàng
                    const qrUrl = `https://img.vietqr.io/image/sacombank-050072093434-compact2.jpg?amount=${result.data.order.total}&addInfo=${orderID}&accountName=DO%20HUU%20BEN`;
                    setQrCodeUrl(qrUrl);

                    // // Thiết lập thông tin thanh toán
                    setMessage(`Email: ${email}
Username: ${username}
Gia hạn: ${thoiHan ? thoiHan.value : ""}
Tổng tiền: ${parseInt(price).toLocaleString('vi-VN')} VNĐ

Ngân hàng: Sacombank
Số tài khoản: 050072093434
Chủ tài khoản: DO HUU BEN
Nội dung: ${orderID}

(Lưu ý: Nhập đúng nội dung để đơn hàng được xử lý tự động)`);

                    // Hiển thị modal chứa mã QR thanh toán
                    // setModal(true);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gia hạn thất bại',
                        text: result.data.message || 'Đã xảy ra lỗi khi gia hạn',
                        showConfirmButton: true
                    })
                }
            }).catch(error => {
                setShowload(false)
                if (error.response) {
                    if (error.response.status === 404) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Không tìm thấy người dùng',
                            text: 'Người dùng không tồn tại hoặc đã bị xóa',
                            showConfirmButton: true
                        })
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Lỗi từ máy chủ',
                            text: error.response.data.message || 'Đã xảy ra lỗi khi gia hạn',
                            showConfirmButton: true
                        })
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Lỗi kết nối',
                        text: 'Không thể kết nối đến máy chủ, vui lòng thử lại sau',
                        showConfirmButton: true
                    })
                }
            })
    }

    function copyToClipboard() {
        setShowCopy(true)
        var textField = document.createElement('textarea')
        textField.value = message
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()
    }

    const style = {
        maxHeight: '400px',
        minHeight: '300px',
        resize: 'none',
        padding: '9px',
        boxSizing: 'border-box',
        fontSize: '15px',
        marginTop: '25px'
    };

    return (
        <div className="content">
            <NotificationAlert ref={notificationAlertRef} />

            <Row>
                <Col lg="6" md="6" sm="6">
                    <Card style={{ padding: '15px' }} >
                        <CardHeader>
                            <div className="d-flex justify-content-between align-items-center">
                                <Label style={{ fontSize: '24px', color: 'DimGray', fontWeight: 'bold' }}>Gia hạn</Label>
                            </div>
                        </CardHeader>

                        <CardBody>
                            <FormGroup>
                                <Label for="username">Tài khoản hoặc Email</Label>
                                <InputGroup style={{ display: 'flex', alignItems: 'center', marginTop: '-5px' }}>
                                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} style={{ marginRight: 0 }}>
                                        <DropdownToggle caret color="primary" style={{
                                            borderTopRightRadius: 0,
                                            borderBottomRightRadius: 0,
                                            height: '38px',
                                            padding: '6px 12px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}>
                                            {toolName}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {toolList && toolList.length > 0 ? (
                                                toolList.map((tool) => (
                                                    <DropdownItem
                                                        key={tool.code || tool.id}
                                                        onClick={() => {
                                                            setSelectedTool(tool.code || tool.id);
                                                            setToolName(tool.name);
                                                            setUserData(null);
                                                            setUsername('');
                                                            setVersion('');
                                                            setEmail('');
                                                            setFullName('');
                                                            setAccountStatus('');
                                                        }}
                                                    >
                                                        {tool.name}
                                                    </DropdownItem>
                                                ))
                                            ) : (
                                                <DropdownItem disabled>Không có công cụ</DropdownItem>
                                            )}
                                        </DropdownMenu>
                                    </Dropdown>
                                    <Input
                                        value={userFind}
                                        id="userFind"
                                        onChange={handleSearchChange}
                                        onKeyPress={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                lookupUser();
                                            }
                                        }}
                                        autoComplete="off"
                                        style={{
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            marginLeft: 0,
                                            borderTopRightRadius: 0,
                                            borderBottomRightRadius: 0,
                                            height: '38px',
                                            padding: '6px 12px',
                                            verticalAlign: 'middle'
                                        }}
                                    />
                                    <Button
                                        className="btn btn-info"
                                        type="button"
                                        onClick={lookupUser}
                                        style={{
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            marginLeft: 0,
                                            margin: 0,
                                            height: '38px',
                                            padding: '6px 12px',
                                            verticalAlign: 'middle'
                                        }}
                                    >
                                        {showlookup || isSearching ? <span className="spinner-border spinner-border-sm"></span> : 'Tìm kiếm'}
                                    </Button>
                                </InputGroup>
                                {showUserDropdown && userList.length > 0 && (
                                    <div className="user-dropdown" style={{
                                        position: 'absolute',
                                        zIndex: 1000,
                                        width: '100%',
                                        backgroundColor: 'white',
                                        border: '1px solid #ced4da',
                                        borderRadius: '0.25rem',
                                        boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
                                        marginTop: '5px'
                                    }}>
                                        {userList.map((user, index) => (
                                            <div
                                                key={index}
                                                className="user-item"
                                                onClick={() => selectUser(user)}
                                                style={{
                                                    padding: '10px 15px',
                                                    borderBottom: index < userList.length - 1 ? '1px solid #eeeeee' : 'none',
                                                    cursor: 'pointer'
                                                }}
                                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                                onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                            >
                                                <div style={{ fontWeight: 'bold' }}>{user.username}</div>
                                                <div style={{ fontSize: '0.9em', color: '#6c757d' }}>{user.fullname} - {user.email}</div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </FormGroup>
                        </CardBody>
                    </Card>

                    {userData && (
                        <Card style={{ padding: '15px' }}>
                            <CardHeader>
                                <div className="d-flex justify-content-between align-items-center">
                                    <Label style={{ fontSize: '24px', color: 'DimGray', fontWeight: 'bold' }}>Tài khoản</Label>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <div className="form-row" style={{ marginTop: '-10px' }}>
                                    <div className="form-group col-md-4">
                                        <Label style={{ marginTop: "1rem" }} for="fullname">Họ tên</Label>
                                        <Input
                                            value={fullName}
                                            id="fullname"
                                            disabled
                                        />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Label style={{ marginTop: "1rem" }} for="email">Email</Label>
                                        <Input
                                            value={email}
                                            id="email"
                                            disabled
                                        />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Label style={{ marginTop: "1rem" }} for="username">Username</Label>
                                        <Input
                                            value={username}
                                            id="username"
                                            onChange={(e) => setUsername(e.target.value)}
                                            disabled
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <Label style={{ marginTop: "1rem" }} >Trạng thái tài khoản</Label>
                                        <Input
                                            value={accountStatus}
                                            id="accountStatus"
                                            disabled
                                            style={{ color: accountStatus === 'Đã hết hạn' ? '#dc3545' : '#28a745', fontWeight: 'bold' }}
                                        />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <Label style={{ marginTop: "1rem" }} for="currentExpired">Ngày hết hạn</Label>
                                        <Input
                                            value={moment(userData.expired).format('MM/DD/YYYY')}
                                            id="currentExpired"
                                            disabled
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-md-4">
                                        <Label style={{ marginTop: "1rem" }} for="loai">Loại</Label>
                                        <Input
                                            value={version}
                                            id="loai"
                                            disabled
                                        />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Label style={{ marginTop: "1rem" }} for="thoihan">Thời hạn gia hạn</Label>
                                        <Select
                                            styles={{
                                                menu: (provided) => ({ ...provided, zIndex: 199 }),
                                                container: (provided) => ({ ...provided, zIndex: 199 })
                                            }}
                                            isSearchable={false}
                                            placeholder={thoiHan ? thoiHan.value : "Chọn thời hạn"}
                                            value={thoiHan}
                                            onChange={(e) => setThoiHan(e)}
                                            options={optionsThoiHan}
                                        />
                                    </div>
                                    <div className="form-group col-md-4">
                                        <Label style={{ marginTop: "1rem" }} for="newExpired">Ngày hết hạn mới</Label>
                                        <Input
                                            value={
                                                thoiHan ? (
                                                    moment(userData.expired).isAfter(moment())
                                                        ? moment(userData.expired).add(thoiHan.exp, 'days').format('MM/DD/YYYY')
                                                        : moment().add(thoiHan.exp, 'days').format('MM/DD/YYYY')
                                                ) : ''
                                            }
                                            id="newExpired"
                                            disabled
                                        />
                                    </div>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <Label style={{ marginTop: "1rem" }} for="price">Tổng tiền</Label>
                                        <Input
                                            value={price}
                                            id="price"
                                            onChange={(e) => setPrice(e.target.value)}
                                        />
                                    </div>
                                    <div className="form-group col-md-6">
                                        <Label style={{ marginTop: "1rem" }} for="paymentMethod">Phương thức thanh toán</Label>
                                        <Select
                                            styles={{
                                                menu: (provided) => ({ ...provided, zIndex: 196 }),
                                                container: (provided) => ({ ...provided, zIndex: 196 })
                                            }}
                                            isSearchable={false}
                                            placeholder={paymentMethod}
                                            value={paymentMethod}
                                            onChange={(e) => setPaymentMethod(e.value)}
                                            options={optionsPaymentMethod}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                            <CardFooter>
                                <Button
                                    className='btn btn-primary'
                                    style={{ marginRight: "10px" }}
                                    onClick={() => createSuccessExtendOrder()}
                                >
                                    Gia hạn {showload ? <span className="spinner-border spinner-border-sm"></span> : null}
                                </Button>
                                <Button
                                    className='btn btn-warning'
                                    style={{ marginRight: "10px" }}
                                    onClick={() => createWaitingExtendOrder()}
                                >
                                    Chờ thanh toán {showload ? <span className="spinner-border spinner-border-sm"></span> : null}
                                </Button>
                            </CardFooter>
                        </Card>
                    )}
                </Col>

                {order && (
                    <Col lg="6" md="6" sm="6">
                        <Card style={{ padding: '15px' }}>
                            <CardHeader>
                                <div className="d-flex justify-content-between align-items-center">
                                    <Label style={{ fontSize: '24px', color: 'DimGray', fontWeight: 'bold' }}>Thông tin thanh toán</Label>
                                </div>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col md="6">
                                        <div className="border-right pr-3">
                                            <textarea rows="10" style={style} className="form-control" value={message} />
                                            <Button
                                                onClick={copyToClipboard}
                                                className="btn btn-info mt-3"
                                            >
                                                {showCopy ? 'Đã sao chép' : 'Sao chép thông tin'}
                                            </Button>
                                        </div>
                                    </Col>
                                    <Col md="6">
                                        {paymentMethod === "Chuyển khoản" ? (
                                            <>
                                                <div className="text-center">
                                                    <h5>Quét mã QR để thanh toán</h5>
                                                    <div className="qr-code-container" style={{ marginTop: "15px", marginBottom: "15px" }}>
                                                        {order ? (
                                                            <>
                                                                <img
                                                                    src={qrCodeUrl}
                                                                    alt="QR Code thanh toán"
                                                                    style={{ maxWidth: "100%", height: "auto" }}
                                                                />
                                                            </>
                                                        ) : (
                                                            <div className="placeholder" style={{
                                                                width: "100%",
                                                                height: "200px",
                                                                backgroundColor: "#f8f9fa",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                border: "1px dashed #ccc",
                                                                borderRadius: "4px"
                                                            }}>
                                                                <p className="text-muted">Mã QR đang được tải...</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="alert alert-info h-100 d-flex align-items-center justify-content-center">
                                                <div className="text-center">
                                                    <h4>Phương thức thanh toán</h4>
                                                    <p className="lead mt-3"><strong>{paymentMethod}</strong></p>
                                                    <p>Vui lòng liên hệ admin để biết thêm chi tiết.</p>
                                                </div>
                                            </div>
                                        )}
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                )}
            </Row>
        </div>
    )
}

export default OrderExtend 